import { useCurrentClient } from '@pbk-web/state';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { FormTemplateConfigurationPagedFilter } from '../models/Form';
import ClientTemplateModuleService from '../services/ClientTemplateModuleService';

export const useFetchFormTemplatesConfiguration = (filter: FormTemplateConfigurationPagedFilter, disabled: boolean) => {
  const currentClient = useCurrentClient((x) => x.value);

  const service = useMemo(() => currentClient && new ClientTemplateModuleService(currentClient.id), [currentClient]);

  return useInfiniteQuery({
    queryKey: ['form-templates-configuration', currentClient?.id, filter],
    staleTime: 5 * 60 * 1000, // 5 minutes
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      return service!.getAllTemplateFormDefaults({ ...filter, pageNumber: pageParam });
    },
    getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? (lastPage.pageNumber ?? 0) + 1 : undefined;
    },
    enabled: !!currentClient && !disabled,
  });
};
